import {ShareableLink} from '@app/drive/shareable-link/shareable-link';
import {validateDatatableSearch} from '@common/datatable/filters/utils/validate-datatable-search';
import {PaginatedBackendResponse} from '@common/http/backend-response/pagination-response';
import {queryFactoryHelpers} from '@common/http/queries-file-helpers';
import {keepPreviousData, queryOptions} from '@tanstack/react-query';
import {User} from '@ui/types/user';

// the admin list eager-loads the creator and includes created_at, which the
// public ShareableLink type doesn't carry
export interface AdminShareableLink extends ShareableLink {
  created_at?: string;
  user?: Pick<User, 'id' | 'name' | 'email'> | null;
}

const get = queryFactoryHelpers.get;

export const adminShareableLinksQueryKey = ['admin-shareable-links'];

export function adminShareableLinksQuery(
  search: Record<string, string> = {},
) {
  const params = validateDatatableSearch(search);
  return queryOptions({
    placeholderData: keepPreviousData,
    queryKey: [...adminShareableLinksQueryKey, params],
    queryFn: ({signal}) =>
      get<PaginatedBackendResponse<AdminShareableLink>>(
        'shareable-links',
        params,
        signal,
      ),
  });
}
